module.exports = " <div class=container _v-26bd69a6=\"\"> <router-view _v-26bd69a6=\"\"></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-26bd69a6&file=app.vue!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/static_page/app.vue
// module id = 642
// module chunks = 13